var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c("form-forgotten-password", {
        attrs: {
          fetching: _vm.fetching,
          message: _vm.message,
          "message-type": _vm.messageType,
        },
        on: { submit: _vm.submit },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("h1", { staticClass: "title is-bold" }, [_vm._v("Forgot password?")]),
      _c("p", [
        _vm._v(
          " Enter the email address associated wth your account, and we'll send you a link to reset your password. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }